<div class="ed">
  <div class="ed__header">
    <!-- Severity badge -->
    <div class="ed__badge">
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" aria-hidden="true">
        <path
          d="M7.5 2v5.5M7.5 10.5v.5"
          stroke="#fff"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </div>

    <!-- Title -->
    <h2 id="ed-dialog-title" class="ed__title">{{ data.title }}</h2>

    <!-- Error count badge (only when multiple errors) -->
    @if (data.errors.length > 1) {
      <span class="ed__count" [attr.aria-label]="data.errors.length + ' errors'">
        {{ data.errors.length }}
      </span>
    }

    <!-- Dismiss -->
    <button class="ed__dismiss" mat-dialog-close aria-label="Close dialog">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
        <path
          d="M1 1l10 10M11 1L1 11"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    </button>
  </div>

  <mat-dialog-content class="ed__body">
    <ul class="ed__list">
      @for (err of visibleErrors; track $index) {
        <li class="ed__item">{{ err }}</li>
      }
    </ul>

    @if (hasMore) {
      <button class="ed__toggle" type="button" (click)="seeMore = !seeMore">
        {{ toggleLabel }}
      </button>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="ed__footer" align="end">
    <button class="ed__close-btn" mat-dialog-close>Close</button>
  </mat-dialog-actions>
</div>
